import _find from "lodash/find";
export default {
  namespaced: true,

  state: {
    entries: [],
    taxonomies: {}
  },

  getters: {
    stores(state, getters, rootState, rootGetters) {
      // return rootState.config.data.stores || {};
      // if (
      //   rootState.config.data &&
      //   rootState.config.data.hasOwnProperty("stores")
      // )
      //   return rootState.config.data.stores;
      if (rootGetters["config/account"]) {
        return rootGetters["config/account"].stores;
      }
      return {
        entries: [],
        taxonomies: {}
      };
    },
    brands(state, getters) {
      // return state.taxonomies.brand || [];
      return getters.stores.taxonomies.brand || [];
    },
    zones(state, getters) {
      // return state.taxonomies.zone || [];
      return getters.stores.taxonomies.zone || [];
    },
    programs(state, getters) {
      // return state.taxonomies.program || [];
      return getters.stores.taxonomies.program || [];
    },
    entries(state, getters) {
      // return state.entries || [];
      return getters.stores.entries || [];
    },
    getEntryByID: (state, getters) => id => {
      return _find(getters.stores.entries, { ID: id });
    }
    // getEntryByID: state => id => {
    //   return _find(state.entries, { ID: id });
    // }
  },

  actions: {
    mutate({ commit }, payload) {
      if (payload) {
        commit("mutateStoresState", payload);
      }
    }
  }
};
